{
  "artifact": {
    "about": "Allgemein",
    "addTitle": "Artefakt hinzufügen: {{name}}",
    "blockedName": "Geben Sie dem Artefakt einen Namen.",
    "checklist": {
      "addItem": "Punkt hinzufügen",
      "caption": "Punkte der Checkliste",
      "cellOf": "{{column}} von {{name}}",
      "columns": {
        "id": "ID",
        "labels": "Labels",
        "part_type": "Teil",
        "reference": "Fundstelle",
        "requirement": "Anforderung",
        "xbrl_concept": "XBRL-Konzept"
      },
      "hint": "Labels mit „;“ trennen. Anforderungen umschreiben und ihren Absatz nennen."
    },
    "content": "Inhalt",
    "description": "Beschreibung",
    "editPageTitle": "Neue Version von „{{name}}“",
    "editTitle": "Artefakt ändern: {{name}}",
    "editorHints": {
      "annotations": "Annotationen eines Dokuments: am Text bearbeitet, in der Spannenansicht.",
      "checklist": "Bekanntes Schema: als Tabelle bearbeitet, als kanonisches JSON gespeichert.",
      "glossary": "Glossareinträge bearbeiten.",
      "json": "Als JSON bearbeitet; der Server prüft das Artefaktformat.",
      "markdown": "Markdown, gespeichert wie geschrieben."
    },
    "glossary": {
      "addTerm": "Begriff hinzufügen",
      "caption": "Begriffe des Glossars",
      "de": "Deutsch",
      "deOf": "Deutsche Wortlaute von {{name}}",
      "en": "Englisch",
      "enOf": "Englische Wortlaute von {{name}}",
      "hint": "Synonyme mit „;“ trennen. Groß- und Kleinschreibung zählt nicht, daher findet „Entwicklungskosten“ auch Komposita.",
      "importCsv": "CSV importieren…",
      "importProblem": "Die CSV braucht eine Kopfzeile mit einer Spalte „key“ (und „label“, „de“, „en“, „note“).",
      "key": "Schlüssel",
      "keyOf": "Schlüssel von Zeile {{row}}",
      "label": "Label",
      "labelOf": "Label von {{name}}",
      "noLabel": "kein Label",
      "note": "Notiz",
      "noteOf": "Notiz zu {{name}}"
    },
    "hints": {
      "duplicateKey": "„{{key}}“ kommt doppelt vor.",
      "emptyKey": "Zeile {{row}} hat keinen Schlüssel.",
      "labelsWithoutTerm": "Labels ohne Begriff: {{labels}}",
      "noLabel": "„{{key}}“ hat noch kein Label.",
      "title": "Hinweise",
      "unknownLabel": "„{{key}}“: Das Label „{{label}}“ steht nicht in der Labelliste. Als Suchbegriff behalten oder das Label im selben Änderungssatz vorschlagen."
    },
    "intro": "Schreiben Sie Inhalte, die Schritte und Skills lesen sollen.",
    "json": "Inhalt als JSON",
    "jsonInvalid": "Noch kein gültiges JSON; der letzte gültige Inhalt bleibt.",
    "labelsFrom": "Labels aus",
    "mediaType": "Medientyp",
    "name": "Name",
    "newTitle": "Neues Artefakt",
    "noLabelList": "keiner Labelliste",
    "otherSchema": "anderes (rohes JSON)…",
    "removeRow": "Entfernen",
    "removeRowNamed": "Zeile {{name}} entfernen",
    "rowActions": "Aktionen der Zeile",
    "schema": "Schema",
    "schemaName": "Name des Schemas",
    "unnamed": "ohne Namen",
    "versionNotice": "Nach der Übernahme ist dies die nächste Version; gleitende Leser lesen ab dann diese, fixierte behalten ihre.",
    "withAgent": "Agent fragen"
  },
  "artifactPage": {
    "byHand": "Von Hand gemacht: keine Quellen festgehalten.",
    "byPerson": "von einer Person gemacht",
    "byWorkflow": "gemacht vom Prozessschema",
    "changeSet": "Änderungssatz",
    "content": "Inhalt",
    "current": "aktuelle Version",
    "diffLabel": "Änderungen gegenüber der vorigen Version",
    "floating": "gleitend",
    "hideDiff": "Änderungen ausblenden",
    "items_one": "{{count}} Punkt",
    "items_other": "{{count}} Punkte",
    "keptUpToDateBy": "Aktuell gehalten von",
    "loading": "Versionen und Leser des Artefakts werden gelesen…",
    "madeBy": "Gemacht von",
    "madeFrom": "Gemacht aus",
    "newerExists": "neuere Version vorhanden",
    "noMerge": "Nicht aus einem Änderungssatz übernommen (mit dem Projekt geladen).",
    "noVersions": "Noch keine Version übernommen.",
    "notCurrent": "eine frühere Version",
    "openCurrent": "Aktuelle Version öffnen",
    "outdatedHint": "Etwas, woraus es gemacht wurde, hat sich seitdem geändert. Starten Sie einen neuen Durchlauf des Prozessschemas, das es gemacht hat; die Konfliktprüfung führt es als „Bitte ansehen“.",
    "pinned": "fixiert",
    "readBy": "Gelesen von",
    "readByNone": "Noch liest es kein Schritt, Skill oder Prozessschema.",
    "reads": {
      "bundled": "bündelt es als Datei",
      "selector": "eine Auswahlregel nennt es",
      "skill": "bietet einen Skill an, der es bündelt",
      "step": "führt einen Schritt aus, der es liest",
      "sub_workflow": "führt ein Teilprozessschema aus, das es liest"
    },
    "showDiff": "Änderungen zeigen",
    "shown": "angezeigt",
    "storedFile": "Gespeicherte Datei",
    "terms_one": "{{count}} Begriff",
    "terms_other": "{{count}} Begriffe",
    "thread": "Durchlauf",
    "threadEntry": "Durchlauf-Eintrag {{entry}}",
    "version": "v{{number}}",
    "versions": "Versionen",
    "via": "über"
  },
  "ask": {
    "aboutDraft": "Bitte schreib dieses Element ({{kind}}) für mich und schlage es in einem Änderungssatz vor. Mein bisheriger Entwurf („{{name}}“):\n\n```json\n{{draft}}\n```\n",
    "aboutItem": "Zum Element ({{kind}}) „{{name}}“ @ {{reference}}: ",
    "aboutItemWithin": "Zum Element ({{kind}}) „{{name}}“ @ {{reference}}, wie es im Prozessschema @ {{within}} verwendet wird: ",
    "button": "Agent fragen",
    "kinds": {
      "artifact": "Artefakt",
      "capability_overrides": "Fähigkeitskorrekturen",
      "competency_question": "Kompetenzfrage",
      "few_shot_example": "Few-Shot-Beispiel",
      "label_list": "Labelliste",
      "ontology_module": "Ontologiemodul",
      "prompt": "Prompt",
      "shapes": "Shapes",
      "skill": "Skill",
      "step": "Schritt",
      "tool": "Werkzeug",
      "workflow": "Prozessschema"
    },
    "newItem": "Bitte schreib ein neues Element ({{kind}}) für dieses Projekt und schlage es in einem Änderungssatz vor: "
  },
  "bilingual": {
    "blocked": "Name und Beschreibung in jeder begonnenen Sprache schreiben oder diese Sprache leeren.",
    "field": "{{field}} · {{language}}",
    "incomplete": "{{language}}: Name und Beschreibung beide schreiben oder beide leeren."
  },
  "capabilities": {
    "about": "Allgemein",
    "addEntry": "Festlegung hinzufügen",
    "addTitle": "Fähigkeitskorrekturen hinzufügen: {{name}}",
    "agentMatch": "Agentenname (Glob)",
    "blockedEntries": "Fügen Sie mindestens eine Festlegung hinzu.",
    "blockedName": "Geben Sie den Fähigkeitskorrekturen zuerst einen Namen.",
    "chooseKey": "Fähigkeit wählen",
    "description": "Beschreibung",
    "editPageTitle": "Fähigkeitskorrekturen bearbeiten: {{name}}",
    "editTitle": "Fähigkeitskorrekturen bearbeiten: {{name}}",
    "entries": "Festlegungen",
    "entriesHint": "Jede trifft Agenten über ihren eigenen Namen oder APIs über ihren Host und LLMs über die ID; * trifft alles, das Standard-LLM eines Agenten nur mit *.",
    "hostMatch": "API-Host (Glob)",
    "intro": "Halten Sie die Einschätzung Ihres Teams zu LLM-Fähigkeiten fest.",
    "key": "Fähigkeit",
    "loadingVocabulary": "Fähigkeitsvokabular wird geladen…",
    "modelMatch": "LLM-ID (Glob)",
    "name": "Name",
    "newTitle": "Neue Fähigkeitskorrekturen",
    "no": "nein",
    "note": "Begründung",
    "notePlaceholder": "Woher das Team das weiß",
    "removeEntry": "Entfernen",
    "reviewNotice": "Nach dem Übernehmen nutzen Durchläufe, die an die neue Inhaltsversion gebunden sind, diese Korrekturen.",
    "routeKind": "LLM-Route",
    "routeKinds": {"agent": "Agent (ACP)", "api_key": "API mit Schlüssel"},
    "unnamed": "ohne Namen",
    "value": "Wert",
    "yes": "ja"
  },
  "catalogueMissing": "Der Schrittkatalog des Servers war nicht lesbar. Arten von Auswahlregeln, DMW-Werkzeuge und eingebaute Werkzeuge werden darum nur angeboten, soweit der Entwurf sie schon nennt.",
  "changeSet": {
    "add": "Zum Änderungssatz hinzufügen",
    "added": "Zum Änderungssatz hinzugefügt.",
    "adding": "Wird hinzugefügt…",
    "hint": "Ins Projekt wird erst geschrieben, wenn Kuratorinnen und Kuratoren den Änderungssatz übernehmen.",
    "nothingToChange": "Nichts zu ändern: Die neueste Version enthält das schon, darum wurde kein Änderungssatz geöffnet.",
    "openReview": "Review öffnen",
    "openThread": "Durchlauf öffnen",
    "reviewedHere": "Zum Review in diesem Durchlauf übergeben: Der nächste Schritt entscheidet darüber.",
    "title": "Zum Änderungssatz hinzufügen"
  },
  "check": {
    "blocked_one": "So gespeichert ließe sich die Änderung nicht übernehmen: Sie bringt {{count}} neue Shapes-Verletzung.",
    "blocked_other": "So gespeichert ließe sich die Änderung nicht übernehmen: Sie bringt {{count}} neue Shapes-Verletzungen.",
    "checking": "Wird geprüft…",
    "passes": "Keine Probleme: Der Server würde das speichern.",
    "passesShapes": "Keine Probleme: Der Server würde das speichern, und die Shapes des Reviews finden nichts Neues.",
    "preExisting_one": "{{count}} Verletzung gab es schon vor dieser Änderung; sie verhindert das Übernehmen nicht.",
    "preExisting_other": "{{count}} Verletzungen gab es schon vor dieser Änderung; sie verhindern das Übernehmen nicht.",
    "problems_one": "{{count}} Problem: Der Entwurf lässt sich erst hinzufügen, wenn es behoben ist.",
    "problems_other": "{{count}} Probleme: Der Entwurf lässt sich erst hinzufügen, wenn sie behoben sind.",
    "shapesChecking": "Die Definition ist gültig. Die Shapes des Reviews laufen…",
    "showProblems": "Probleme zeigen",
    "title": "Prüfungen durch den Server",
    "uncompared_one": "{{count}} Prüfung führt nur einen Teil ihrer Verletzungen auf und wurde daher nicht mit dem aktuellen Stand verglichen.",
    "uncompared_other": "{{count}} Prüfungen führen nur einen Teil ihrer Verletzungen auf und wurden daher nicht mit dem aktuellen Stand verglichen."
  },
  "definition": {
    "changes_one": "{{count}} Änderung",
    "changes_other": "{{count}} Änderungen",
    "file": "Gespeicherte Datei",
    "label": "Die gespeicherte Definition",
    "title": "Definition",
    "views": "Ansichten der Definition"
  },
  "diff": {
    "becomes": "wird zu",
    "fieldChanges": "Geänderte Felder",
    "noChanges": "Keine Änderungen.",
    "whole": "(gesamt)"
  },
  "edit": {
    "inGraph": "Ein Prozessschema wird in seinem Graphen bearbeitet.",
    "openItem": "Element öffnen",
    "openWorkflow": "Prozessschema öffnen",
    "withAgent": "Elemente dieser Art schreibt der Agent: Text und Code kommen als Text ins Review."
  },
  "item": {
    "edit": "Bearbeiten (neue Version)",
    "editHint": "Öffnet die Durchlauf-Ansicht: von Hand oder mit dem Agenten bearbeiten. Speichern schlägt die nächste Version zum Review vor.",
    "kindOf": "Eine Art von"
  },
  "labelList": {
    "about": "Über diese Labelliste",
    "addLabel": "Label hinzufügen",
    "addTitle": "Labelliste hinzufügen: {{name}}",
    "addValue": "Hinzufügen: {{name}}",
    "blocked": "Der Server muss den Entwurf vor dem Speichern erfolgreich prüfen.",
    "description": "Beschreibung",
    "editPageTitle": "Labelliste bearbeiten: {{name}}",
    "editTitle": "Labelliste ändern: {{name}}",
    "fields": {
      "description": "Beschreibung",
      "examples": "Beispiele (optional)",
      "guidelines": "Richtlinien",
      "key": "Schlüssel",
      "name": "Anzeigename",
      "ontology_terms": "Ontologiebegriffe (optionale IRIs)"
    },
    "intro": "Labels für Annotationen, mit Richtlinien und Beispielen.",
    "label": "Label {{position}}",
    "labels": "Labels",
    "moveDown": "Nach unten",
    "moveUp": "Nach oben",
    "name": "Name",
    "newTitle": "Neue Labelliste",
    "remove": "Entfernen",
    "removeLabel": "Label entfernen",
    "removeValue": "{{name}} {{position}} entfernen",
    "unnamed": "unbenannt"
  },
  "library": {
    "new": {
      "artifacts": "Neues Artefakt",
      "labelLists": "Neue Labelliste…",
      "prompts": "Neuer Prompt mit dem Agenten…",
      "skills": "Neuer Skill",
      "steps": "Neuer Schritt",
      "tools": "Neues Werkzeug mit dem Agenten…",
      "workflows": "Neues Prozessschema mit dem Agenten…"
    },
    "tabs": {
      "artifacts": "Artefakte",
      "capabilities": "Fähigkeiten",
      "labelLists": "Labellisten",
      "prompts": "Prompts",
      "skills": "Skills",
      "steps": "Schritte",
      "tools": "Werkzeuge",
      "workflows": "Prozessschemata"
    },
    "title": "Bibliothek"
  },
  "loadingOptions": "Prozesselemente des Projekts werden gelesen…",
  "markdown": {"empty": "Noch nichts geschrieben.", "preview": "Vorschau", "write": "Schreiben"},
  "selector": {
    "chooseItem": "Element wählen",
    "eachSegment": "jedes Segment vom Typ",
    "examples": {"all": "alle", "matching_subject": "passend zum Gegenstand", "none": "keine"},
    "findItem": "Element in der Bibliothek finden",
    "floatingHint": "Gleitend: Die Inhaltsversion des Durchlaufs entscheidet; der Zug hält sie fest.",
    "includeExamples": "Beispiele",
    "includeGuidelines": "mit Richtlinien",
    "item": "Element, das in {{name}} gelesen wird",
    "json": "Auswahlregel von {{name}} als JSON",
    "jsonInvalid": "Noch keine gültige Auswahlregel; die letzte gültige bleibt.",
    "kinds": {
      "accepted_instance_data": "Angenommene Aussagen",
      "competency_questions": "Kompetenzfragen",
      "corpus_documents": "Dokumente des Korpus",
      "derived_records": "Abgeleitete Datensätze",
      "earlier_results": "Frühere Teile (Referenzkontext)",
      "few_shot_examples": "Few-Shot-Beispiele",
      "item": "Element",
      "label_list": "Labelliste",
      "ontology_terms": "Ontologiebegriffe",
      "reference_vocabularies": "Referenzvokabulare",
      "source_scope": "Quellenauswahl",
      "source_version": "Quellversion",
      "subject_text": "Text des Gegenstands"
    },
    "labelList": "Labelliste, die in {{name}} gelesen wird",
    "notAtMain": "{{item}}… (nicht im aktuellen Stand)",
    "pinned": "fixiert",
    "pinnedHint": "Genau diese Version.",
    "render": "Darstellung",
    "renderings": {"numbered_segments": "nummerierte Segmente", "plain": "schlicht"},
    "scope": "Umfang",
    "scopeOf": "Umfang von {{name}}",
    "segmentType": "Segmenttyp",
    "sourceVersionPaths": "Quellversion: Dateien, die das Tool erhält",
    "sourceVersionPathsHint": "Ein relativer Pfad pro Zeile (mit /). Leer lassen für den gesamten Commit.",
    "sourceVersionPathsInvalid": "Höchstens 100 relative Pfade mit je bis zu 1000 Zeichen, ohne leere, . oder .. Segmente. Die letzte gültige Auswahl bleibt erhalten.",
    "wholeDocument": "das ganze Dokument"
  },
  "similar": {
    "empty": "Keine ähnlichen Elemente gefunden.",
    "invalidUse": "Dieses Element kann diesem Prozessschema nicht hinzugefügt werden.",
    "loading": "Ähnliche Elemente suchen…",
    "noWorkflows": "Keine anderen Prozessschemata verfügbar.",
    "open": "Öffnen",
    "title": "Ähnliche vorhandene Elemente",
    "use": "In einem Prozessschema verwenden"
  },
  "skill": {
    "about": "Allgemein",
    "addFile": "Datei hinzufügen",
    "addTitle": "Skill hinzufügen: {{name}}",
    "blocked": "Der Server muss den Entwurf vor dem Speichern erfolgreich prüfen.",
    "body": "Anleitung (SKILL.md)",
    "bodyHelp": "Markdown: wann der Skill passt, die Schritte, wann Schluss ist. Nennen Sie mitgelieferte Dateien mit ihrem Pfad.",
    "chooseItem": "Werkzeug oder Artefakt finden",
    "description": "Beschreibung",
    "descriptionHelp": "Eine Zeile, die dem Agenten sagt, wann er den Skill nutzen soll. Bis er ihn lädt, liest er nur diese.",
    "filePath": "Pfad der Datei {{position}}",
    "files": "Mitgelieferte Dateien",
    "filesHelp": "Optional. Ein Werkzeug wird in seiner freigegebenen Version mitgeliefert; ein Artefakt wird in der Inhaltsversion des jeweiligen Durchlaufs gelesen.",
    "intro": "Beschreiben Sie, wann der Agent diese Anleitung nutzen soll.",
    "name": "Name",
    "nameHelp": "Kleingeschriebene Wörter mit Bindestrichen, wie der Agent ihn sieht: document-navigation.",
    "newNotice": "Kuratorinnen und Kuratoren von Skills sehen ihn im Review durch. Nach dem Übernehmen ist er Version 1; Schritte können ihn dann ihrem Agenten anbieten.",
    "newTitle": "Neuer Skill",
    "noFiles": "Keine Dateien.",
    "problems": {
      "body_missing": "Schreiben Sie die Anleitung.",
      "description_missing": "Sagen Sie in einer Zeile, wann der Agent ihn nutzen soll.",
      "file_item": "Jede Datei nennt ein Werkzeug oder ein Artefakt.",
      "name_missing": "Geben Sie dem Skill einen Namen."
    },
    "remove": "Entfernen",
    "removeFile": "Datei {{position}} entfernen",
    "source": {"artifact": "Artefakt", "tool": "Werkzeug"},
    "unnamed": "ohne Namen",
    "withAgent": "Den Agenten fragen"
  },
  "source": {
    "accepts": "nimmt {{kinds}}",
    "modes": {"input": "Eingabe", "none": "Nicht genutzt", "selector": "Auswahlregel"},
    "of": "Eingabequelle von {{name}}",
    "required": "erforderlich",
    "selectorOf": "Auswahlregel von {{name}}",
    "slot": "Eingabe: <slot/>",
    "slotHint": "Ein Prozessschema verbindet sie mit der Ausgabe eines früheren Schritts.",
    "slotOf": "Eingabe von {{name}}"
  },
  "step": {
    "about": "Allgemein",
    "addTitle": "Schritt hinzufügen: {{name}}",
    "agent": {
      "allowedKinds": "Elementarten, die der Änderungssatz enthalten darf",
      "compaction": "Kontextverdichtung",
      "destinations": {
        "content_change_set": "in einen Änderungssatz (Datenmodellierung)",
        "knowledge_data": "in Wissensdaten (Extraktion)",
        "thread_log": "im Durchlauf, für einen späteren Schritt"
      },
      "existingPrompt": "Vorhandener Prompt",
      "instructions": "Agentenanweisungen",
      "instructionsHint": "Was der Agent in diesem Schritt über die Anweisungen des Durchlaufs hinaus tut. Ohne Platzhalter.",
      "instructionsName": "{{name}}: Agentenanweisungen",
      "itemTools": "Freigegebene Werkzeuge",
      "labelListIn": "Labelliste in",
      "loadingPrompt": "Prompt wird gelesen…",
      "newPrompt": "Neuer Prompt",
      "newPromptHint": "Ein neuer Prompt wird mit dem Schritt im selben Änderungssatz gespeichert.",
      "noPlaceholders": "Der Prompt hat keine Platzhalter.",
      "noPrompt": "Keine",
      "noSkills": "Das Projekt hat noch keine Skills.",
      "output": "Ausgabe",
      "outputHint": "Was der Schritt liefern muss.",
      "outputRequired": "Die Ausgabe ist erforderlich",
      "outputs": {"annotations": "Annotationen", "change_set": "Änderungssatz", "text": "Text"},
      "placeholders": "Platzhalter",
      "placeholdersHint": "Im Text des Prompts gefunden; jeder mit genau einer Quelle.",
      "prompt": "Aufgabenprompt",
      "promptDescription": "Beschreibung des Prompts",
      "promptHint": "Markdown; {name} ist ein Platzhalter, eine doppelte öffnende Klammer schreibt eine einfache.",
      "promptName": "Name des neuen Prompts",
      "promptText": "Text des Prompts",
      "running": "Sitzung, Verdichtung und Anforderungen",
      "session": "Sitzung",
      "sessions": {"isolated": "Eigene Sitzung", "thread": "Sitzung des Durchlaufs"},
      "skillUse": "Nutzung des Skills {{name}}",
      "skillUses": {"none": "nicht genutzt", "offered": "angeboten", "requested": "angefordert"},
      "skills": "Skills",
      "skillsHint": "Angeboten: Der Agent sieht die Beschreibung und entscheidet. Angefordert: Der Skill wird für den Zug geladen.",
      "tools": "Werkzeuge",
      "toolsHint": "DMW-Werkzeuge, die der Agent aufrufen darf, und freigegebene Werkzeuge, die er ausführen darf."
    },
    "blocked": {
      "name": "Geben Sie dem Schritt einen Namen.",
      "prompt": "Wählen Sie einen Prompt oder schreiben Sie einen neuen.",
      "tool": "Wählen Sie das Werkzeug, das er ausführt."
    },
    "description": "Beschreibung (ein Satz)",
    "editPageTitle": "Neue Version von „{{name}}“",
    "editTitle": "Schritt ändern: {{name}}",
    "human": {
      "addInput": "Eingabe hinzufügen",
      "addOption": "Option hinzufügen",
      "comment": {"optional": "Kommentar optional", "required": "Kommentar erforderlich"},
      "inputs": "Eingaben, die gezeigt werden",
      "inputsHint": "Jede ist eine Eingabe, die ein Prozessschema verbindet.",
      "instructions": "Anleitung",
      "instructionsHint": "Markdown, wird der teilnehmenden Person gezeigt.",
      "newInput": "Name der neuen Eingabe",
      "newOption": "Neue Option",
      "no": "Nein",
      "optionKey": "Schlüssel der Option",
      "optionLabel": "Bezeichnung der Option",
      "removeInput": "Entfernen",
      "removeInputNamed": "Eingabe {{name}} entfernen",
      "removeOption": "Entfernen",
      "response": "Antwort",
      "responseHint": "Was die teilnehmende Person antwortet.",
      "responses": {
        "choice": "Eine Auswahl",
        "review_output": "Review einer Eingabe",
        "text": "Freier Text"
      },
      "reviewedInput": "Eingabe im Review",
      "yes": "Ja"
    },
    "intro": "Fügen Sie den Schritt einem Änderungssatz hinzu, um ihn zum Review zu speichern.",
    "keyNameHint": "Kleinbuchstaben, Ziffern und _, beginnend mit einem Buchstaben.",
    "kind": "Art des Schritts",
    "kindHints": {
      "agent": "Ein Zug des Agenten mit Prompt, Werkzeugen und Skills.",
      "human": "Antwort: Text, Auswahl oder Review.",
      "tool": "Führt ein freigegebenes Werkzeug auf festen Eingaben aus. Kein Agent, kein Prompt."
    },
    "name": "Name",
    "newTitle": "Neuer Schritt",
    "optional": "optional",
    "parameter": {
      "default": "Standard {{value}}",
      "noDefault": "keiner",
      "problems": {
        "aboveMaximum": "Über dem Maximum des Werkzeugs.",
        "belowMinimum": "Unter dem Minimum des Werkzeugs.",
        "notAllowed": "Keiner der Werte des Werkzeugs.",
        "notBoolean": "Muss wahr oder falsch sein.",
        "notInteger": "Muss eine ganze Zahl sein.",
        "notNumber": "Muss eine Zahl sein.",
        "patternMismatch": "Passt nicht zum Muster des Werkzeugs."
      },
      "useDefault": "Standard des Werkzeugs"
    },
    "required": "erforderlich",
    "requirements": {
      "add": "Anforderung hinzufügen",
      "atLeast": "mindestens",
      "capability": "Fähigkeit",
      "equals": "gleich",
      "remove": "Entfernen",
      "removeNamed": "Anforderung {{name}} entfernen",
      "rule": "Regel",
      "title": "Anforderungen an die LLM-Route",
      "value": "Wert"
    },
    "tool": {
      "builtIn": "eingebaut",
      "choose": "Werkzeug wählen",
      "hint": "Freigegebene Werkzeuge des Projekts und eingebaute Werkzeuge.",
      "inputs": "Eingaben",
      "inputsHint": "Genau die, die das Werkzeug erklärt; jede aus einer Auswahlregel oder einer Eingabe.",
      "intoBoundCorpus": "in das Korpus des Durchlaufs, als Änderungssatz, den eine Kuratorin übernimmt ({{mode}})",
      "loading": "Schnittstelle des Werkzeugs wird gelesen…",
      "newArtifact": "neues Artefakt",
      "noInputs": "Das Werkzeug nimmt keine Eingaben.",
      "noItemOutput": "Dieses Werkzeug hat keine Element-Ausgabe, die vorgeschlagen werden kann.",
      "parameters": "Werkzeugparameter",
      "parametersHint": "Leer heißt: der Standardwert des Werkzeugs, der zur Werkzeugversion gehört.",
      "propose": "Ausgabe vorschlagen",
      "proposeHint": "Optional: eine Element-Ausgabe als Artefakt vorschlagen, wenn der Schritt fertig ist.",
      "proposeOutput": "Eine Ausgabe als Artefakt vorschlagen",
      "proposedAs": "Vorgeschlagen als",
      "proposedName": "Name des vorgeschlagenen Artefakts",
      "proposedOutput": "Vorzuschlagende Ausgabe",
      "reviewed": "freigegeben",
      "title": "Werkzeug"
    },
    "unnamed": "ohne Namen",
    "versionNotice": {
      "inRoot": "Als Kopie gespeichert; das Prozessschema, in dem er steht, nutzt sie nach der Übernahme.",
      "inWorkflow": "Dieses Prozessschema nutzt die neue Version, sobald Sie es speichern.",
      "pinned": "Prozessschemata behalten die fixierte Version, bis sie aktualisiert werden."
    },
    "withAgent": "Stattdessen mit dem Agenten schreiben"
  },
  "unsaved": {
    "body": "Speichern Sie Ihre Änderungen als Entwurf in einem Änderungssatz, verwerfen Sie sie oder bearbeiten Sie sie weiter.",
    "drop": "Verwerfen",
    "keep": "Weiter bearbeiten",
    "save": "Als Entwurf speichern",
    "saveFailed": "Der Entwurf konnte nicht gespeichert werden. Bearbeiten Sie ihn weiter und sehen Sie Formular und Änderungssatz durch.",
    "title": "Ungespeicherte Änderungen"
  }
}
